import React, { useState, useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import { useTable, useGlobalFilter } from "react-table";
import { useLocation } from "react-router-dom";
import "bootstrap/dist/css/bootstrap.min.css";
import Modal from "react-bootstrap/Modal";
import { listAdminUserData, selectAdminListData } from "./adminListSlice";
import Col from "react-bootstrap/Col";
import Button from "react-bootstrap/Button";
import { Row, Container, Badge } from "react-bootstrap";
import Table from "react-bootstrap/Table";
import { selectUser } from "../auth/authSlice";
import { SurveyRequestModal } from "../homepage-banner/surveyRequestModal";
import { getSurveyRequests } from "../usersurveyrequest/surveyRequestSlice";
import {
  selectSurveyRequest,
  selectAdminSurveyRequest,
  getAdminsSurveyRequests,
} from "../usersurveyrequest/surveyRequestSlice";

export const ButtonPanels = () => {
  const [modalShow, setModalShow] = useState(false);
  const [requestsModalShow, setRequestsModalShow] = useState(false);
  const dispatch = useDispatch();
  const adminlist = useSelector(selectAdminListData);
  const surveyRequestRecords = useSelector(selectSurveyRequest);
  const adminSurveyRequestRecords = useSelector(selectAdminSurveyRequest);
  const user = useSelector(selectUser);
  const [status, setStatus] = useState([]);
  const location = useLocation();
  const ext_id = location.state?.cso_id;
  const user_id = user.cso_identifier;
  let org_id;
  let external;
  let surveys;

  if (user.groups.includes("EXTERNAL_USERS")) {
    external = true;
    org_id = ext_id;
  } else if (user.groups.includes("BUSINESS_USERS")) {
    surveys = surveyRequestRecords;
    org_id = user_id;
  } else if (user.groups.includes("BUSINESS_ADMINS")) {
    surveys = adminSurveyRequestRecords;
    org_id =user_id;
  }

  useEffect(() => {
    if (user.groups.includes("BUSINESS_ADMINS")) {
      dispatch(getAdminsSurveyRequests());
    } else if (user.groups.includes(["BUSINESS_ADMINS" || "BUSINESS_USERS"])){
      dispatch(getSurveyRequests());
    }
  }, []);

  const requestHandler = (status) => {
    if (user.groups.includes("BUSINESS_ADMINS")) {
      dispatch(getAdminsSurveyRequests());
    } else {
      dispatch(getSurveyRequests());
    }
    setStatus(status);
    setRequestsModalShow(true);
  };

  function AdminTable({ adminlist }) {
    const data = React.useMemo(() => {
      if (!Array.isArray(adminlist)) return [];
  
      return adminlist.map((adminRow) => {
        const email = adminRow.email || "No email available";
        const username = adminRow.username || "No name available";
        const mailto = email !== "No email available" ? `mailto:${email}` : "#";
  
        return {
          emailDisplay: (
            <a href={mailto} target="_blank" rel="noopener noreferrer">
              {email}
            </a>
          ),
          email,
          username,
        };
      });
    }, [adminlist]);
  
    const columns = React.useMemo(() => [
      {
        Header: "Email",
        accessor: "emailDisplay", // rendered JSX
      },
      {
        Header: "Username",
        accessor: "username",
      },
    ], []);
  
    const {
      getTableProps,
      getTableBodyProps,
      headerGroups,
      rows,
      prepareRow,
      state,
      setGlobalFilter,
    } = useTable(
      {
        columns,
        data,
      },
      useGlobalFilter
    );
  
    const { globalFilter } = state;
  
    return (
      <>
        <div className="mb-2">
          <input
            className="form-control"
            placeholder="Search username"
            value={globalFilter || ""}
            onChange={(e) => setGlobalFilter(e.target.value)}
          />
        </div>
  
        <table {...getTableProps()} className="table table-bordered">
          <thead>
            {headerGroups.map(headerGroup => (
              <tr {...headerGroup.getHeaderGroupProps()}>
                {headerGroup.headers.map(column => (
                  <th {...column.getHeaderProps()}>
                    {column.render("Header")}
                  </th>
                ))}
              </tr>
            ))}
          </thead>
          <tbody {...getTableBodyProps()}>
            {rows.length > 0 ? (
              rows.map(row => {
                prepareRow(row);
                return (
                  <tr {...row.getRowProps()}>
                    {row.cells.map(cell => (
                      <td {...cell.getCellProps()}>
                        {cell.render("Cell")}
                      </td>
                    ))}
                  </tr>
                );
              })
            ) : (
              <tr>
                <td colSpan="2">No matching administrators found.</td>
              </tr>
            )}
          </tbody>
        </table>
      </>
    );
  }

  function MydModalWithGrid(props) {
    return (
      <Modal
        {...props}
        aria-labelledby="contained-modal-title-vcenter"
        size="xl"
      >
        <Modal.Header closeButton>
          <Modal.Title id="contained-modal-title-vcenter">
            Administrators List
          </Modal.Title>
        </Modal.Header>
        <Modal.Body className="grid-example">
          <Container>
            <AdminTable adminlist={adminlist} />
          </Container>
        </Modal.Body>
        <Modal.Footer>
          <Button onClick={props.onHide}>Close</Button>
        </Modal.Footer>
      </Modal>
    );
  }
  return (
    <Row>
      <Col>
        <Button variant="warning" onClick={() => {
          dispatch(listAdminUserData(org_id))
          setModalShow(true)}}>
          Administrators
        </Button>
      </Col>
      <MydModalWithGrid show={modalShow} onHide={() => setModalShow(false)} />
      <SurveyRequestModal
        show={requestsModalShow}
        surveys={surveys}
        status={status}
        onHide={() => setRequestsModalShow(false)}
      />
      {external ? null : (
        <>
          {/* <Col>
            <Button
              variant="success"
              style={{
                whiteSpace: "nowrap",
                height: "auto",
                width: "auto",
                padding: "0.375rem 0.75rem",
                color: "white",
              }}
              onClick={()=>{requestHandler(['ACCEPTED','REJECTED'])}}
            >
              Previous Requests
            </Button>
          </Col> */}
          <Col>
            <Button
              variant="secondary"
              onClick={()=>{requestHandler(['PENDING'])}}
              style={{
                whiteSpace: "nowrap",
                height: "auto",
                width: "auto",
                padding: "0.375rem 0.75rem",
              }}
            >
              Requests
              <Badge bg="secondary" style={{ fontSize: "1rem" }}>
                {surveys.filter(item=>item.sr_status=='PENDING').length}
              </Badge>
            </Button>
          </Col>
        </>
      )}
    </Row>
  );
};

export default ButtonPanels;
